module.exports = __webpack_public_path__ + "vue/img/logo4.d94c4202.png";